/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:17:14
 */
export default {
  lang: "英语",
  landing: {
    name1: "פתח את Carlcare",
    name2: "שמור מקום מראש",
    name3: "באמצעות Carlcare תוכל לבדוק את הזמנתך בכל עת.",
    name4: "",
    name5: "החלק ימינה",
    name6: "האימות הושלם",
    name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02130204983.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
  },
  order: {
    name1: "בחר דגם מכשיר",
    name2: "תיאור תקלה:",
    name3: "הקש כדי לבחור חנות שירות",
    name4: "חנות שירות:",
    name5: "זמן תור:",
    name6: "אנא תאר בפירוט את בעיית המכשיר שלך!",
    name7: "הקש כדי לבחור זמן הגעה",
    name8: "אנא הזן את פרטי ההתקשרות הנכונים שלך כדי שנוכל ליצור איתך קשר",
    name9: "זמן ההזמנה הזמין הוא כדלקמן",
    name10: "נא הכנס את מספר הטלפון שלך",
    name11: "מחיר",
    name12: "מידע אישי:",
    name13: "אנא הכנס את שמך",
    name14: "שלח",
    name15: "ביטול",
    name16: "בסדר",
  },
  shops: {
    name1: "מבוסס על המותג שבחרת, החנויות הבאות יכולות לשרת אותך!",
    name2: "מגיע בקרוב בעוד חנויות קמעונאיות! השאר עמנו!",
  },
  price: {
    name1: "מותג",
    name2: "דגם",
    name3: "פריט",
    name4: "מחיר",
    name5: "תזכורת ידידותית:",
    name6: "מחירים אלה הם רק לעיון, והמחיר בפועל כפוף למצב המכשיר שלך.",
    name7: "אם אין סמל מיוחד,  המחיר הוא במטבע המקומי.",
    name8: "מצטערים! אין מידע על מחיר באזור הנוכחי.",
    name11:"עלות עבודה",
    name12:"מחיר כולל",
    name13: "5. אם עלות העבודה היא \"/\", פירוש הדבר הוא שיש להתייעץ עם החנות בנוגע לעלות העבודה.",
    item_main_board: "לוח ראשי",
    item_screen_frame: "מסך (מסגרת)",
    item_screen_screen_frame: "מסך משני (מסגרת)",
    item_touch_screen: "מסך מגע",
    item_camera: "מצלמה",
    item_fixed_focus_camera: "מצלמה עם מוקד קבוע",
    item_auto_focus_camera: "מצלמה עם מוקד אוטומטי",
    item_screen: "מסך",
    item_secondary_screen: "מסך משני",
    item_fingerprint_module: "מודול טביעת אצבע",
    item_speaker: "רמקול",
    item_receiver: "מקלט",
    item_small_board: "לוח קטן",
    item_battery_cover: "מכסה סוללה",
    item_battery: "סוללה",
    item_charger: "מטען",
    item_usb_cable: "כבל USB",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "אין נתונים.",
    name2: "ספק שירות:",
    name3: "מותג שירות:",
    name4: "טלפון:",
    name5: "כמות של הזמנה:",
    name6: "דירוג שירות",
    name7: "סביבת שירות:",
    name8: "יחס שירות:",
    name9: "יעילות השירות:",
    name10: "איכות השירות:",
    name11: "הערכת לקוחות",
    name12:"עד",
    name13:"סגור",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "פתח את Carlcare",
    name1: "אנא קח צילום מסך של פרטי ההזמנה ושמור אותם כקבלה כדי לגשת לשירות העדיפות.",
    name2: "הוגש בהצלחה",
    name3: "1. נקה נתונים",
    name4: "אנא גבה מראש נתונים פרטיים חשובים בטלפון שלך",
    name5: "2. השבת את סיסמת ההפעלה",
    name6: "לפני שאתה ניגש לחנות שירותים, אנא:",
    name7: "חנות שירות:",
    name8: "זמן תור:",
    name9: "תיאור תקלה:",
    name10: "דגם מכשיר:",
    name11: "מספר הזמנה:",
    name12: "מידע אודות הזמנה",
  },
  title: {
    
    name1: "תומך במדינות הבאות:",
    name2: "בחר דגם",
    name3: "מקום שמור",
    name4: "פרטי חנות שירות",
    name5: "בחר חנות שירות",
  },
  error: {
    
    name1: "אין מידע. אנא בדוק את פרטי התיקון שלך",
    name2: "צריך עזרה? אנא צור קשר איתנו.",
    name3: "מצטערים, אין מרכז Carlcare באזור הנוכחי.",
    name4: "אנא בחר תחילה מרכז שירות",
    name5: "נכשל",
    name6: "אנא בחר תחילה את דגם המכשיר",
    name7: "פרטים",
    name8: "אנא תאר את צרכיך בפירוט",
    name9: "",
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "Pick-up Time",
    "name7": "Tap to select pick-up time",
    "name8": "Pick-up Address",
    "name9": "Please input your house number/street/district/province",
    "name10": "Please input your postal code",
    "name11": "Add returning address",
    "name12": "Returning Address",
    "name13": "אחרים",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"הקש כדי להכווין מחדש",
    name3:"פתח את האפליקציה Carlcare כדי לדרג את ההזמנה",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"בחר שירות",
    name7:"ניקוי חופשי",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "מידע שגוי",
    "cancelReason1": "לא יכול להגיע בזמן",
    "cancelReason2": "הזמנה כפולה/לא הזמנה שלי",
    "cancelReason3": "התקלה אינה חוזרת",
    "cancelReason4": "רק לצורך בדיקה/שאילתה/אירוע/…",
    "cancelReason5": "מחיר גבוה",
    "cancelReason6": "מחסור בחומרים",
    "cancelReason7": "אין שירותים ספציפיים",
    "cancelReason8": "החנות רחוקה מדי",
    "cancelReason9": "החנות סגורה",
    "cancelReason10": "גישת שירות גרועה",
    "cancelReason11": "תחליף/תיקון של מותגים אחרים",
    "cancelReason12": "לא ניתן למצוא את החנות",
    "cancelReason13": "אחרת",
    "cancelOrder": "בטל הזמנה",
    "reason_dialog_title": "אנא ספר לנו את סיבת הביטול",
    "Cancel": "ביטול",
    "OK": "אישור",
    "name1": "הזן קוד אימות",
    "name2": "קוד אימות לא תקף",
    "repair_reservation_detail_canceled": "הזמנה זו התבטלה!",
    "purchase_cancel_dialog_content": "האם אתה מאשר לבטל את ההזמנה?",
    "yes": "כן",
    "no": "לא"
}
};
